import Axios from 'axios';

export default {
  
  demo() {
    return Axios('http://www.monoame.com/awi_class/api/command.php?type=get&name=itemdata')
    .then((response) => {
      const {
        data,
      } = response;

      return data;
    })
    .catch(error => console.log(error));
  },
  // other methods
};



// WEBPACK FOOTER //
// ./src/services/demo.js